import type {FilterProvider, SuppliedFilterProvider} from '@github-ui/filter'
import {NestedFilterProvider} from '@github-ui/filter/providers'

import {tokenizeQuery} from './tokenize-query'
import type {QuerySegment} from './types'

export function validateQueryKeys(query: string, providers?: SuppliedFilterProvider[]): QuerySegment[] {
  if (!providers) return []

  const keysSet = new Set<string>()
  for (const provider of flattenProviders(providers)) {
    keysSet.add(provider.key)
    for (const alias of provider.aliases || []) {
      keysSet.add(alias)
    }
  }

  const isInvalid = (segment: QuerySegment) => segment.type === 'text' || !keysSet.has(segment.key)

  return tokenizeQuery(query).filter(isInvalid)
}

function flattenProviders(providers: SuppliedFilterProvider[]): FilterProvider[] {
  const flattenedProviders: FilterProvider[] = []
  for (const provider of providers) {
    if (provider instanceof NestedFilterProvider) {
      flattenedProviders.push(...provider.filterProviders)
    } else {
      flattenedProviders.push(provider)
    }
  }

  return flattenedProviders
}
